import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Layout = ({ isLoading, children, className }) => (
  <div
    className={cn('cr-layout', 'cr-sans-serif', className, {
      'cr-layout__loading': isLoading,
    })}
  >
    {children}
  </div>
);

Layout.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Layout;
export { default as LayoutContent } from './Content';
export { default as LayoutSection } from './Section';
